import React, { Component } from 'react'
import "react-table/react-table.css"
import moment from 'moment'
import { connect } from 'react-redux'


@connect((store)=>{
  return {
    saldo: store.transactions.saldo,
    saldoInicio: store.transactions.saldoInicio,
    currentSettings: store.user.currentSettings
  } 
})
class Stats extends Component {

  componentWillMount() {
    this.getBalance()
  }

  getSaldo = (date) => {

    let inicio = moment().subtract(10,'years')
    let fim = moment(date)
    let dataShow = this.props.transactions.filter(x => {
      return x.processado
    })

    let saldoinicial = dataShow.filter(x => {
        return moment(x.data).isSameOrAfter(inicio,'day') && moment(x.data).isSameOrBefore(fim,'day')
    })

    let saldo = saldoinicial.reduce((init,x)=>{
        return  Number((x.debito? init - x.valor : init + x.valor).toFixed(2))
    },0)

    return saldo
  }

  getBalance = () =>{

    const filterProcessado = this.props.transactions.filter(x => this.props.currentSettings.processado.value === 'todos' ? true :
    (this.props.currentSettings.processado.value === 'sim' ? x.processado : !x.processado))

    let positives = filterProcessado.filter(x => {
      return !x.debito
    }).reduce((init,x)=>{
      return init + x.valor
    },0)

    let negatives = filterProcessado.filter(x => {
      return x.debito
    }).reduce((init,x)=>{
      return init + x.valor
    },0)
    return positives-negatives
  }

  getPendentes = () => {

    let pendentes = this.props.transactions.filter(x => {
      return !x.processado
    })
    return pendentes.length

  }

  getCreditos = () => {
    const filterProcessado = this.props.transactions.filter(x => this.props.currentSettings.processado.value === 'todos' ? true :
    (this.props.currentSettings.processado.value === 'sim' ? x.processado : !x.processado))

    return filterProcessado.filter(x => {
      return !x.debito
    }).reduce((init,x)=>{
      return init + x.valor
    },0)

  }

  getDebitos = () => {
    const filterProcessado = this.props.transactions.filter(x => this.props.currentSettings.processado.value === 'todos' ? true :
    (this.props.currentSettings.processado.value === 'sim' ? x.processado : !x.processado))

    return filterProcessado.filter(x => {
      return x.debito
    }).reduce((init,x)=>{
      return init + x.valor
    },0)

  }
  

  render() {

    return (
      <div className="stats">
          <div className="item">
          <span className="stats-title"><i className="fas fa-list-ul"/> Registros</span>
          <div className="stats-number">{this.props.transactions.length}</div>
          </div>
          <div className="divider"></div>
          <div className="item">
          <span className="stats-title"><i className="fas fa-balance-scale"/> Balanço</span>
          <div className="stats-number">R${this.getBalance().toLocaleString('pt-BR')}</div>
          
          </div>
          <div className="divider"></div>
          <div className="item">
          <span className="stats-title"><i className="fas fa-money-bill-alt"/> Total créditos</span>
          <div className="stats-number">R${(this.getCreditos()).toLocaleString('pt-BR')}</div>
          
          </div>
          <div className="divider"></div>
          <div className="item">
          <span className="stats-title"><i className="fas fa-money-bill-alt"/> Total Débitos</span>
          <div className="stats-number">R${(this.getDebitos()).toLocaleString('pt-BR') }</div>
          
          </div>
          <div className="divider"></div>
          <div className="item">
          <span className="stats-title"><i className="fas fa-clock"/> Pendentes</span>
          <div className="stats-number">{this.getPendentes()}</div>
          
          </div>
      </div>
    );
  }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/components/Stats.js